import { render } from "./NewLicenseSectionApplicant.vue?vue&type=template&id=6d9b6258&scoped=true"
import script from "./NewLicenseSectionApplicant.vue?vue&type=script&lang=js"
export * from "./NewLicenseSectionApplicant.vue?vue&type=script&lang=js"

import "./NewLicenseSectionApplicant.vue?vue&type=style&index=0&id=6d9b6258&lang=postcss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d9b6258"]])

export default __exports__